module.exports = __webpack_public_path__ + "img/maintenance.1cefbeab.png";